// @ts-nocheck
/* eslint-disable */
export const InfoIcon = {
    data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="11.2" fill="#1D53A4" stroke="#1D53A4" stroke-width="1.6"/>
        <path d="M12.0001 17.6841C12.6317 17.6841 13.137 17.0526 13.137 16.421V11.621C13.137 10.9894 12.6317 10.4841 12.0001 10.3578C11.3685 10.3578 10.8633 10.9894 10.8633 11.621V16.421C10.8633 17.0526 11.3685 17.5578 12.0001 17.6841Z" fill="white"/>
        <path d="M12.0001 8.0842C12.6317 8.0842 13.137 7.45262 13.137 6.82105C13.137 6.18947 12.6317 5.6842 12.0001 5.6842C11.3685 5.6842 10.8633 6.31578 10.8633 6.82105C10.8633 7.45262 11.3685 8.0842 12.0001 8.0842Z" fill="white"/>
        </svg>
        `,
    name: 'info' as const
};